import { Component } from 'react';
import { withRouter } from 'react-router';
import track from '../../lib/track';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
      track(this.props.loggedIn);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
